import { useContext, useState, useEffect } from "react";
import { LocaleContext } from "./LocaleProvider.js";
function useLocale() {
  const context = useContext(LocaleContext);
  return context;
}
function useLocalizationResources({ messagesMap }) {
  const [messages, setMessages] = useState({});
  const { locale, isInitialized } = useLocale();
  useEffect(() => {
    if (isInitialized) {
      messagesMap[locale]?.()?.then((module) => setMessages(module));
    }
  }, [locale, isInitialized]);
  return { messages };
}
export {
  useLocale,
  useLocalizationResources
};
//# sourceMappingURL=hooks.js.map
